import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const CDN_BASE = import.meta.env.VITE_CDN_URL || 'https://papacitoapp.b-cdn.net';

export function cdnUrl(path: string): string {
  if (!path) return '';
  if (path.startsWith('https://') || path.startsWith('http://')) {
    if (path.includes('papacitoapp.b-cdn.net')) return path;
    const r2Match = path.match(/https:\/\/pub-[a-f0-9]+\.r2\.dev\/(.+)/);
    if (r2Match) return `${CDN_BASE}/${r2Match[1]}`;
    return path;
  }
  if (path.startsWith('/api/uploads/')) return path;
  if (path.startsWith('/')) return `${CDN_BASE}${path}`;
  return `${CDN_BASE}/${path}`;
}

export function optimizedImg(
  path: string,
  opts: { width?: number; height?: number; quality?: number; format?: string } = {}
): string {
  const base = cdnUrl(path);
  if (!base || !base.includes(CDN_BASE)) return base;
  const params = new URLSearchParams();
  if (opts.width) params.set('width', String(opts.width));
  if (opts.height) params.set('height', String(opts.height));
  params.set('quality', String(opts.quality ?? 85));
  params.set('format', opts.format ?? 'webp');
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function formatTimeAgo(dateString: string) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return 'Just now';
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d`;

  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
